var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 417.002 306.871",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(0 -175.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M555.734,405.491a30.281,30.281,0,0,0-24.18,12.023,19.937,19.937,0,0,0-27.818,18.309h82.331a30.332,30.332,0,0,0-30.333-30.333Z",
    transform: "translate(-270.642 -208.629)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M669.467,384.5H309.134a18.2,18.2,0,0,0-18.177,18.177V673.194a18.2,18.2,0,0,0,18.177,18.177H669.467a18.2,18.2,0,0,0,18.177-18.177V402.677A18.2,18.2,0,0,0,669.467,384.5Zm16.038,288.694a16.058,16.058,0,0,1-16.039,16.039H309.134A16.058,16.058,0,0,1,293.1,673.194V402.677a16.058,16.058,0,0,1,16.039-16.038H669.467a16.058,16.058,0,0,1,16.038,16.039Z",
    transform: "translate(-270.642 -208.629)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 80.727,
    cy: 80.727,
    r: 80.727,
    transform: "translate(0 209.017)",
    fill: "#95bdf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M687.644,613.391V635.77H290.957V613.284L293.1,610.2l125.764-181.1a6.2,6.2,0,0,1,10.179,0l84.341,121.433,60.037-85.689a6.2,6.2,0,0,1,10.158,0l101.93,145.48Z",
    transform: "translate(-270.642 -208.629)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M378.1,661.432H315.015a1.069,1.069,0,0,1,0-2.139H378.1a1.069,1.069,0,1,1,0,2.138Z",
    transform: "translate(-270.642 -208.629)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M473.262,661.432H410.177a1.069,1.069,0,0,1,0-2.139h63.085a1.069,1.069,0,1,1,0,2.138Z",
    transform: "translate(-270.642 -208.629)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M568.424,661.432H505.339a1.069,1.069,0,0,1,0-2.139h63.085a1.069,1.069,0,0,1,0,2.138Z",
    transform: "translate(-270.642 -208.629)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M663.586,661.432H600.5a1.069,1.069,0,0,1,0-2.139h63.085a1.069,1.069,0,1,1,0,2.138Z",
    transform: "translate(-270.642 -208.629)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M490.9,456.139a37.359,37.359,0,0,0-29.833,14.834,24.6,24.6,0,0,0-34.321,22.589H528.327A37.423,37.423,0,0,0,490.9,456.139Z",
    transform: "translate(-270.642 -208.629)",
    fill: "#ccc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.82957d936e57d5bb5e39e21236e214b5.svg";
export { ForwardRef as ReactComponent };